import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=abd50208&scoped=true"
import script from "./invoice-detail.vue?vue&type=script&lang=js"
export * from "./invoice-detail.vue?vue&type=script&lang=js"
import style0 from "./invoice-detail.vue?vue&type=style&index=0&id=abd50208&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd50208",
  null
  
)

export default component.exports